import { connectWithHammock, ENDPOINTS } from 'hammock';
import React from 'react';

import { getAllowedFields } from '@candu-ai/collections/utils';
import {
  CollectionFallbacksEditor,
  CollectionFieldsEditor,
  useAvailableCollectionFields,
} from 'craft/components/SelectedToolbar/Collections';
import { Section } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';
import { CollectionTargetLocation } from 'craft/types';

export interface CollectionFieldEditorProps {
  nodeIds: string[];
  // TODO => targetLocation to be set by the parent component, following what property is being changed (ie text vs ActionUrl for ex)
  targetLocation?: CollectionTargetLocation;
}

export const CollectionFieldEditorImpl = React.memo(({ nodeIds }: CollectionFieldEditorProps) => {
  const { type, collections } = useMultiNodes(nodeIds, (node) => ({
    collections: node?.data.custom.collections,
  }));

  const availableFields = useAvailableCollectionFields({
    nodeIds,
  });

  const collectionEmbedLocations = getAllowedFields(type, availableFields);

  if (Object.keys(collectionEmbedLocations).length < 1) {
    return null;
  }

  return (
    <Section name="Collection Settings">
      <CollectionFieldsEditor
        nodeIds={nodeIds}
        collections={collections}
        type={type}
        collectionEmbedLocations={collectionEmbedLocations}
      />
      <CollectionFallbacksEditor
        nodeIds={nodeIds}
        sortOrder={Object.keys(collectionEmbedLocations) as CollectionTargetLocation[]}
      />
    </Section>
  );
});

export const CollectionFieldEditor = connectWithHammock({
  endpoint: ENDPOINTS.collections,
})(CollectionFieldEditorImpl);
